
import { mapActions } from 'vuex'

export default {
  name: `AccountSignupPage`,
  data() {
    return {
      provider: 'spendgo',
    }
  },
  head() {
    return this.$utils.head(this.story)
  },
  async asyncData({ $utils }) {
    return {
      story: await $utils.content('account/signup')
    }
  },
  async beforeMount() {
    // Redirect to SSO
    const redirect = await this.sendRequest({
      method: 'get',
      headers: {
        client_type: 'web'
      },
      url: 'members/auth',
      params: {
        redirect_uri: process.env.SPENDGO_REDIRECT_URI,
        code: true
      }
    }).then(res => {
      return res.data.url + '&hide_header=true' //add querystring param to hide the header in the olo sign in/up window
    }).catch(err => {
      return null
    })
    if (redirect) {
      window.location = redirect
    } else {
      this.$router.push('/')
    }
    return false
  },
  computed: {},
  methods: {
    ...mapActions([ 'sendRequest' ]),
  }
}
